// vuex
import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'
import * as actions from './actions'

Vue.use(Vuex)

// root state object.
// each Vuex instance is just a single state tree.
const state = {
    loading: false, // 整个页面loading
    loadingText: '', // 整个页面loading描述
    vLoading: false,  // 内容区域loading
    vLoadingText: '', // 内容区域loading描述
    token: window.localStorage.getItem('token'),
    userInfo: window.localStorage.getItem('userInfo'),
    isCollapse: false
}

const mutations = {
    [types.CHANGELOADING](state, val) {
        state.loading = val
    },
    [types.CHANGELOADINGTEXT](state, val) {
        state.loadingText = val
    },
    [types.CHANGEVLOADING](state, val) {
        state.vLoading = val
    },
    [types.CHANGEVLOADINGTEXT](state, val) {
        state.vLoadingText = val
    },
    [types.SETTOKEN](state, val) {
        state.token = val
        if (!val) {
            window.localStorage.removeItem('token')
        } else {
            window.localStorage.setItem('token', val)
        }
    },
    [types.SETUSERINFO](state, val) {
        state.userInfo = val
        if (!val) {
            window.localStorage.removeItem('userInfo')
        } else {
            window.localStorage.setItem('userInfo', val)
        }
    },
    collapseMenu(state) {
        console.log('state',state)
        state.isCollapse = !state.isCollapse
        console.log('123',state.isCollapse)
    },

}

// getters are functions
// 有时候我们需要从 store 中的 state 中派生出一些状态，例如对列表进行过滤并计数
const getters = {
    loading: state => state.loading,
    token: state => state.token,
    userInfo: state => state.userInfo,
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})
